<template>
  <div
    :class="{
      'banner__item': true,
      'banner__item_big': bigPicture,
      'banner__item_active': active
    }"
  >
    <div class="banner__info" v-if="bigPicture && visibleDescription">
      <div class="banner__info-contant">
        <h2 class="banner__info-title">{{ title }}</h2>
        <p class="banner__info-description">{{ description }}</p>
      </div>
      <button class="banner__info-btn">Подробнее</button>
    </div>
    <span class="banner__item-close"
      v-if="!bigPicture"
      @click.stop="$emit('delete')"
    >
      <trashСanIcon/>
    </span>
    <img
      :class="{
        'banner__file': true,
        'banner__file_active': active
      }"
      :src="envUrlBase + urlBanner"
      alt=""
      v-if="urlBanner !== ''"
    >
  </div>
</template>

<script>
import trashСanIcon from '@/components/icons/trashСanIcon.vue'
export default {
  name: 'BannerUploaderItem',
  components: {
    trashСanIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    bigPicture: {
      type: Boolean,
      default: false
    },
    urlBanner: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    visibleDescription: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    let envUrlBase = null

    if (localStorage.activeProject === 'site') {
      envUrlBase = process.env.VUE_APP_URL_BASE + '/'
    } else if (localStorage.activeProject === 'education') {
      envUrlBase = process.env.VUE_APP_URL_EDUCATION + '/'
    }
    // const envUrlBase = process.env.VUE_APP_URL_EDUCATION + '/'
    return {
      envUrlBase
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  &__item {
    position: relative;
    width: 244px;
    height: 91px;
    border-radius: 6px;
    background-color: #F5F5F5;
    z-index: 1;
    border: 1px solid #787878;

    &_active {
      outline: 3px solid #1BA6DA;

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #00ABEC40;
      }
    }

    &_big {
      width: 100%;
      height: 100%;
    }

    &-close {
      position: absolute;
      top: 8px;
      right: 8px;
      display: block;
      cursor: pointer;
      padding: 4px;
      border-radius: 4px;
      background-color: #C51B0E;
      transition: 0.5s;

      &:hover {
        background-color: #A11208;
      }
      &:active {
        background-color: #7B0D05;
      }
    }
  }

  &__info {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 22px;
    width: 30%;
    background:rgba(0, 0, 0, 0.50);
    border-radius: 6px 0px 0px 6px;

    &-contant {
      display: flex;
      flex-direction: column;
      gap: 25px;
      width: 100%;
      word-wrap: break-word;
    }

    &-title {
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      color: #FFF;
    }

    &-description {
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      color: #FFF;
    }

    &-btn {
      padding: 3px 30px;
      width: 168px;
      height: 28px;
      color: #FFF;
      border: 1px solid #FFF;
      background: transparent;
    }
  }

  &__file {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}
</style>
